<template>
  <NoteList
          :delete-permission="'delete_receipt'"
          :change-permission="'change_receipt'"
          :object-uuid="receipt.uuid" plural-object-name="receipts" object-name="receipt"/>
</template>

<script>
  import NoteList from "./../../../notes/NotesList";
  import {createNamespacedHelpers} from "vuex";

  const {mapState} = createNamespacedHelpers('receipts');

  export default {
    name: "Notes",
    components: {NoteList},
    computed: {
      ...mapState({
        receipt: state => state.view.currentReceipt,
      }),
    },
  }
</script>

<style scoped>

</style>
